import type { DataMaster } from '@/features/ap_payees/components/PayeeDetailDrawer/types';
import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import { FC } from 'react';
import { Header } from '../Header';
import { ServiceRows } from '../ServiceRows';

type Props = {
  services: DataMaster['apAiServiceSettings'];
  isEditable: boolean;
  isEditDisabled: boolean;
  onEdit: (event: React.MouseEvent) => void;
};

export const View: FC<Props> = ({
  services,
  isEditable,
  isEditDisabled,
  onEdit,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Header>
        {isEditable && (
          <ButtonV2 onClick={onEdit} isSecondary isDisabled={isEditDisabled}>
            {t('edit')}
          </ButtonV2>
        )}
      </Header>
      <ServiceRows
        services={services}
        renderValue={(service) => (
          <p>
            {service.is_enabled
              ? t('ai_service_setting.service_in_use')
              : t('ai_service_setting.service_not_in_use')}
          </p>
        )}
      />
    </>
  );
};

View.displayName = 'ApAiServiceSettingsView';
